// src/redux/authReducer.js

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  userId: "",
  firstName: "",
  lastName: "",
  avatar: "",
  role: "",
  Mobilenumber:"",
  Email:""
};

const useSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginUser(state, action) {
      //debugger;
      state.isAuthenticated = true;
      //state.user = action.payload.user;
      state.userId = action.payload.user.id;
      state.firstName = action.payload.user.firstName;
      state.lastName = action.payload.user.lastName;
      state.avatar = action.payload.user.avatar;
      state.role = action.payload.user.role;
      state.Mobilenumber=action.payload.user.Mobilenumber;
      state.Email=action.payload.user.Email;
    },
    logoutUser(state) {
      //   debugger;
      state.isAuthenticated = false;
      state.userId = "";
      state.firstName = "";
      state.lastName = "";
      state.avatar = "";
      state.role = "";
      state.Mobilenumber ="";
      state.Email = ""
    },
  },
});

export const { loginUser, logoutUser } = useSlice.actions;
export default useSlice.reducer;
